import React from 'react';

const SharedMsg = () => {

    return (
        <div className="SharedMsg md-gray" aria-label="Description indicating report results limit">
            Report results are limited to first 500 entries. Use the Bulk Download function to access additional reporting data.
        </div>
    );
};

export default SharedMsg;
